import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2, Download } from "lucide-react";

export function ExportDataCard() {
  const [busy, setBusy] = useState(false);
  const exportNow = async () => {
    setBusy(true);
    try {
      const res = await api.get("/shop-export.xlsx", { responseType: "blob" });
      const name = (res.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || "dados-oficina.xlsx";
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success("Arquivo baixado");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="export-data-card" className="rounded-xl border border-zinc-800 bg-zinc-950/70 p-5 md:p-7">
      <div className="flex items-center gap-2 mb-2"><FileSpreadsheet className="h-4 w-4 text-green-brand" /><h2 className="font-display text-lg font-bold uppercase text-zinc-100">Meus dados</h2></div>
      <p className="text-sm text-zinc-400 mb-4">Baixe uma planilha Excel com os dados desta oficina: clientes, veículos, ordens e itens, estoque, fornecedores, financeiro, agendamentos e funcionários. Senhas e chaves não são incluídas.</p>
      <Button data-testid="export-data-btn" onClick={exportNow} disabled={busy} className="bg-green-brand hover:bg-green-brandDark text-white font-bold uppercase">
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Download className="h-4 w-4 mr-2" />} {busy ? "Gerando..." : "Exportar dados da oficina"}
      </Button>
    </div>
  );
}
